import { render, staticRenderFns } from "./PriorityIcon.vue?vue&type=template&id=ba620d3a&scoped=true"
import script from "./PriorityIcon.vue?vue&type=script&lang=js"
export * from "./PriorityIcon.vue?vue&type=script&lang=js"
import style0 from "./PriorityIcon.vue?vue&type=style&index=0&id=ba620d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba620d3a",
  null
  
)

export default component.exports